import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const Notification = ({
    title='Notification',
    text='Notification text!',
    operation='Okay', 
    variant='secondary',
    show=false,
    setShow,
    onClose=() => {}
}) => {
    const handleClose = () => {
        setShow(false);
        onClose();
    }
    return (
        <div className='dialog-root'>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{text}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant={`${variant} raised-button`} onClick={handleClose}>{operation}</Button>
                </Modal.Footer>
            </Modal>
        </div>
        
    );
}

export default Notification;